<template>
	<PageTemplate>
		<template slot="title">
			News & Views
		</template>
		<template slot="content">
			<v-layout>
				<v-flex xs12>	
					<v-container 
						grid-list-xl
						fluid
						class="divider-line"
						v-for="(item,i) in items"
						:key="i"
					>
						<v-layout row wrap>
							<v-flex xs12 sm4 class="image-border">
								<div
									class="gallery-item"
									:style="'background-image:url('+item.img+');'"
								/>
							</v-flex>
							<v-flex xs12 sm8 >
								<a :href="item.link" target="blank">
									<h2>{{item.title}}</h2>
								</a>
								<p class="published-info">
									{{item.date}}
								</p>
								<p>
								{{item.text}}
								<br>
								<br>
									<a :href="item.link" target="blank"><v-icon>open_in_new</v-icon> {{item.link}} </a>
								</p>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
			</v-layout>
		</template>
	</PageTemplate>
</template>

<script>
import PageTemplate from './PageTemplate'
export default {
  name: 'news',
  data () {
    return {
		items:[
			{
				img:'./img/news/news1.jpg',
				title:'Taking inventory with shotgun EM',
				date:'August 31, 2018',
				link:`http://www.nature.com/articles/s41592-018-0132-x`,
				text:`
					Nature Methods features Verbeke et al. in Research Highlights.
					`,
			},
		]
    }
  },
  components:{
	PageTemplate
  }
}
</script>

<style scoped>
img{
	width:100%;
	height:auto;
	border: 1px solid #cccccc;
	padding:5px;
}
p{
	text-align:justify;
}
h2{
	padding-top:0;
	margin-bottom:0;
	font-size:30px;
}
.divider-line{
	border-bottom: 1px solid #cccccc;
}
.published-info{
	font-size:14px;
	color:#000000;
	padding-left:10px;
}
a h2:hover{
	color:#bf5700;
}
.gallery-item{
	width:100%;
	height:100%;
	min-height:230px;
	display:inline-block;
	background-repeat:no-repeat;
	background-size:cover;
	background-position:top,center;
}
.image-border{
	border: 1px solid #cccccc;
	padding:5px !important;
	margin:10px 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue